var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 0.638979C12.9999 0.872947 12.8665 1.03618 12.7052 1.19125C11.0705 2.78822 9.43856 4.38519 7.80661 5.98488C7.54249 6.24333 7.28394 6.50178 7.01704 6.75752C6.68342 7.07582 6.31922 7.08398 5.99395 6.76568C4.07286 4.88849 2.15455 3.00859 0.236246 1.12868C-0.0695707 0.829418 -0.075131 0.451261 0.200104 0.184646C0.469779 -0.0765281 0.867341 -0.060205 1.1676 0.230895C2.86627 1.89044 4.56495 3.5527 6.26362 5.21496C6.42302 5.37094 6.5787 5.37366 6.73069 5.22312C8.41824 3.57174 10.103 1.92308 11.7878 0.271703C11.9546 0.105749 12.1325 -0.0139551 12.3855 0.00236797C12.7275 0.0241327 12.9999 0.298909 12.9999 0.636259V0.638979Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.0f05d77a4530d5c9ad91b73e05d8a1f3.svg";
export { ForwardRef as ReactComponent };